import http, { Http } from '../../../../lib/http';

function validateTokenCtor(http: Http) {
  return async function validateToken(token: string) {
    await http.get(`/auth/v1/reset-password/${token}`);
  };
}

export const validateToken = validateTokenCtor(http);
